import { Button, Input, Label, Form, FormGroup } from "reactstrap";
import { Link } from "react-router-dom";
import useData from "./data";

const RegisterPage = () => {
  const {
    username,
    setUsername,
    email,
    setEmail,
    password,
    setPassword,
    handleSubmit,
    loading,
  } = useData();

  return (
    <div className="m-2 mt-4">
      <Form onSubmit={handleSubmit}>
        <FormGroup>
          <Label for="username">Username</Label>
          <Input
            type="text"
            id="username"
            value={username}
            onChange={(event) => setUsername(event.target.value)}
            required
          />
        </FormGroup>
        <FormGroup>
          <Label for="email">Email</Label>
          <Input
            type="email"
            id="email"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />
        </FormGroup>

        <FormGroup>
          <Label for="password">Password</Label>
          <Input
            type="password"
            id="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            required
          />
        </FormGroup>
        <Button
          type="submit"
          color="primary"
          className="w-100 mt-3"
          disabled={loading}
        >
          Register
        </Button>
      </Form>

      <hr />
      <div className="mt-2">
        <Link to="/login" className="btn btn-primary w-100">
          Already have an account? Login
        </Link>

        <Link to="/forgot-password" className="btn btn-primary w-100 mt-2">
          Forgot Password?
        </Link>
      </div>
    </div>
  );
};

export default RegisterPage;
